import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { FIRST_PAGE, MAX_PER_PAGE } from 'constants/constants';
import {
  ContextLibraryUploadedFileTypePage,
  QueryContextLibraryUploadedFilesArgs
} from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryContextLibraryUploadedFilesArgs;
type TData = ContextLibraryUploadedFileTypePage;

const MOCK: TVariables = {
  id: undefined,
  page: FIRST_PAGE,
  perPage: MAX_PER_PAGE,
  query: undefined,
  skipPagination: undefined,
  sortAttribute: undefined,
  sortOrder: undefined,
  tagId: undefined
};

export const useContextLibraryData = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query contextLibraryUploadedFiles(
      $id: ID
      $tagId: ID
      $sortAttribute: ContextLibraryUploadedFileSortAttributeEnum
      $query: String
      $sortOrder: SortOrderEnum
      $page: Int
      $perPage: Int
    ) {
      contextLibraryUploadedFiles(
        id: $id
        tagId: $tagId
        query: $query
        sortAttribute: $sortAttribute
        sortOrder: $sortOrder
        page: $page
        perPage: $perPage
      ) {
        pagesCount
        nodesCount
        nodes {
          id
          filename
          filesize
          createdAt
          extension
          processed
          errorMessage
          tags {
            id
            name
          }
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useContextLibraryData', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
